import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchDropdown from "../../input/SearchDropdown";
import {
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../store/request-slice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { validateRequestTransport } from "../../validations/validateRequestCreation";
import { FORMS, MODULES } from "../../../const";
import { validateQuickRequestTransport } from "../../validations/ValidateQuickRequestCreation";

const FORM = FORMS.QUICK_REQUEST.TRANSPORT.form;

const QuickRequestTransport = forwardRef(({ dropdown, editMode }, ref) => {
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.request.requestTransporterErrors);
  const [currentErrors, setCurrentErrors] = useState(errors ?? {});
  useEffect(() => {
    setCurrentErrors(errors ?? {});
  }, [errors]);

  const vehicleMaxCbm = useSelector((state) => state.request.vehicleMaxCbm);
  const currentValues = useSelector(
    (state) => state.request.currentValues.requestTransporterData,
  );
  const nextButtonErrors = useSelector(
    (state) => state.error.requestCreationErrors.transportErrors,
  );

  const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);
  const customerId = useSelector((state) => state.request.reqLCustomerId);
  const plantId = useSelector((state) => state.request.reqLPlantId);

  console.log("customer id", customerId);
  console.log("plant id", plantId);

  const prevValueRef = useRef("");

  const [requestTransporter, setRequestTransporter] = useState({
    reqItemTypes: 7,
    reqManageItems: 2,
    reqMultiConsignee: 2,
    reqConsignmentType: null,
    reqVehicleTypeId: null,
    reqContainerType: null,
    reqContainerno: "",
    reqNumberOfVehicles: null,
    reqNumberOfTrailers: null,
    reqGrossWeight: null,
    reqTotalValye: null,
    reqConsignee: null,
    reqConsigneeCbm: null,
    reqConsigneeQty: null,
    reqConfirmationStatus: 1,
    reqCreationType: 1,
  });

  useEffect(() => {
    setCurrentErrors((prevState) => ({
      ...prevState,
      ...nextButtonErrors,
    }));
  }, [nextButtonErrors]);

  useEffect(() => {
    if (editMode && currentValues) {
      setRequestTransporter(currentValues.requestTransporter);
      setSingleConsignee(currentValues.singleConsigneeData);
    }
  }, [editMode, currentValues]);

  const [singleConsignee, setSingleConsignee] = useState({
    rcoLocation: null,
    rcoConsignee: null,
    rcoCbm: null,
    rcoCbmUom: null,
    rcoQty: null,
    rcoQtyUom: null,
    rcoActive: 1,
  });

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const [multiConsignmentType, setMultiConsignmentType] = useState("");

  useImperativeHandle(ref, () => ({
    getData: () => requestTransporter,
    getSingleConsignee: () => singleConsignee,
    validateForm: () => {
      return validateQuickRequestTransport(requestTransporter);
    },
    validateMultiConsignee: () => {
      if (requestTransporter.reqMultiConsignee === 2) {
        if (singleConsignee.rcoCbm === null || singleConsignee.rcoCbm === "") {
          return "CBM is required";
        } else {
          if (singleConsignee.rcoCbm === 0) {
            return "CBM is required";
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    },
  }));

  useEffect(() => {
    (async () => {
      if (requestTransporter.reqVehicleTypeId) {
        const response = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_vehicle_type",
          primaryKey: "vht_id",
          ids: requestTransporter.reqVehicleTypeId.toString(),
          fieldNames: "vht_max_cbm",
        });
        if (response && response.length > 0) {
          dispatch(
            requestActions.setRequest({
              vehicleMaxCbm: parseFloat(response[0].field1),
            }),
          );
        }
      }
    })();
  }, [requestTransporter.reqVehicleTypeId, dispatch]);

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <div className="field">
            <div className="two fields">
              <SearchDropdown
                readOnly={viewOnlyMode}
                key={1}
                editMode={editMode}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                value={requestTransporter.reqVehicleTypeId}
                form={FORM}
                module={MODULES.Transaction}
                field="req_vehicle_type"
                threshold={1}
                clearable={true}
                onClear={() => {
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqVehicleTypeId: null,
                  }));
                }}
                onResultSelect={(data) =>
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqVehicleTypeId: data,
                  }))
                }
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "req_vehicle_type",
                  value: "customer_shipper",
                  param2: customerId?.toString(),
                  param4: plantId?.toString(),
                }}
                fieldInfo={{
                  tableName: "masterdata.tms_m_vehicle_type",
                  primaryKey: "vht_id",
                  fieldName: "vht_type",
                  id: requestTransporter.reqVehicleTypeId,
                }}
                required={true}
                label="Vehicle Type"
                error={currentErrors.reqVehicleTypeId}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { reqVehicleTypeId: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
              <div className=" field">
                <label>Max CBM</label>
                <input
                  type="number"
                  min={0}
                  name="maxcbm"
                  value={vehicleMaxCbm}
                  readOnly
                />
              </div>
              <Input
                required={requestTransporter.reqMultiConsignee === 2}
                readOnly={viewOnlyMode}
                disabled={
                  requestTransporter.reqMultiConsignee === 1 ||
                  requestTransporter.reqVehicleTypeId === null ||
                  requestTransporter.reqVehicleTypeId === "" ||
                  vehicleMaxCbm === null
                }
                label="CBM"
                error={currentErrors.rcoCbm}
                form={FORM}
                module={MODULES.Transaction}
                field="req_singaleconsignee_cbm"
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { rcoCbm: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type="number"
                step="0.01"
                min={0}
                max={parseFloat(vehicleMaxCbm)}
                name="cbm"
                value={singleConsignee?.rcoCbm}
                onChange={(e) => {
                  let value = e.target.value;
                  const regex = /^\d*\.?\d{0,2}$/;

                  if (!regex.test(value)) {
                    value = prevValueRef.current;
                    setCurrentErrors((prevState) => ({
                      ...prevState,
                      rcoCbm: "Allow only two decimal places",
                    }));
                  } else {
                    prevValueRef.current = value;
                    setCurrentErrors((prevState) => {
                      const { rcoCbm: _, ...rest } = prevState;
                      return rest;
                    });
                  }

                  if (parseFloat(value) > parseFloat(vehicleMaxCbm)) {
                    toast.error(
                      "CBM should be less than or equal to vehicle max cbm",
                      { autoClose: 3000, containerId: "Main" },
                    );
                  }
                  dispatch(
                    requestActions.setRequest({
                      reqCbm: value,
                    }),
                  );
                  setSingleConsignee((prevState) => ({
                    ...prevState,
                    rcoCbm: value,
                  }));
                }}
              />
            </div>
            <div className="three fields">
              <Dropdown
                required={true}
                readOnly={viewOnlyMode}
                label="Multiple Consignees"
                error={currentErrors.reqMultiConsignee}
                form={FORM}
                module={MODULES.Transaction}
                field="req_multi_consignee"
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { reqMultiConsignee: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Yes/No"
                name="multiConsignee"
                options={dropdown.yesNoOptions}
                value={requestTransporter.reqMultiConsignee}
                style={{
                  height: "20px",
                }}
                onChange={(e, data) => {
                  dispatch(
                    requestActions.setRequest({
                      reqMultiConsignee: data.value,
                      singleConsignee: null,
                      reqCbm: 0,
                      reqQty: 0,
                    }),
                  );
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqMultiConsignee: data.value,
                  }));
                  setSingleConsignee((prevState) => ({
                    ...prevState,
                    rcoQty: "",
                    rcoCbm: "",
                  }));
                }}
              />

              <SearchDropdown
                readOnly={viewOnlyMode}
                key={1}
                disabled={requestTransporter.reqMultiConsignee === 1}
                editMode={editMode}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                value={singleConsignee?.rcoConsignee}
                form={FORM}
                module={MODULES.Transaction}
                field="req_singaleconsignee_consignee"
                clearable={true}
                onClear={() => {
                  setSingleConsignee((prevState) => ({
                    ...prevState,
                    rcoConsignee: null,
                  }));
                  dispatch(
                    requestActions.setRequest({
                      singleConsignee: null,
                    }),
                  );
                }}
                onResultSelect={(data) => {
                  setSingleConsignee((prevState) => ({
                    ...prevState,
                    rcoConsignee: data,
                  }));
                  dispatch(
                    requestActions.setRequest({
                      singleConsignee: data,
                    }),
                  );
                }}
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "stakeholder_type",
                  value: "Consignee",
                 
                }}
                fieldInfo={{
                  tableName: "masterdata.tms_m_stakeholder",
                  primaryKey: "stk_id",
                  fieldName: "stk_name",
                  id: singleConsignee?.rcoConsignee?.toString(),
                }}
                label="Consignees"
              />
              <Input
                readOnly={viewOnlyMode}
                label="Gross Weight"
                error={currentErrors.reqGrossWeight}
                form={FORM}
                module={MODULES.Transaction}
                field="req_gross_weight"
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { reqGrossWeight: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type="number"
                min={0}
                name="gross_weight"
                value={requestTransporter.reqGrossWeight}
                onChange={(e) => {
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqGrossWeight: e.target.value,
                  }));
                }}
              />
            </div>

            <div className="three fields">
              <SearchDropdown
                readOnly={viewOnlyMode}
                disabled={viewOnlyMode}
                key={1}
                editMode={editMode}
                reset={searchFieldReset}
                setReset={setSearchFieldReset}
                value={requestTransporter.reqContainerType}
                form={FORM}
                module={MODULES.Transaction}
                field="req_container_type"
                clearable={true}
                onClear={() => {
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqContainerType: null,
                  }));
                }}
                onResultSelect={(data) =>
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqContainerType: data,
                  }))
                }
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "container_type",
                  value: "",
                }}
                threshold={1}
                fieldInfo={{
                  tableName: "masterdata.tms_m_container_type",
                  primaryKey: "cot_id",
                  fieldName: "cot_discription",
                  id: requestTransporter.reqContainerType?.toString(),
                }}
                label="Container Type"
              />
              <Input
                readOnly={viewOnlyMode}
                label="Container No"
                error={currentErrors.reqContainerno}
                form={FORM}
                module={MODULES.Transaction}
                field="req_containerno"
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { reqContainerno: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Container No"
                value={requestTransporter.reqContainerno}
                onChange={(e) =>
                  setRequestTransporter((prevState) => ({
                    ...prevState,
                    reqContainerno: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
});

export default QuickRequestTransport;
